import { type AuthError } from "firebase/auth";

export enum GlobalRoleEnum {
	GLOBAL_ADMIN = "global_admin",
	SCOPED_USER = "scoped_user",
	GLOBAL_TENANT_ADMIN = "global_tenant_admin",
}

export enum TenantRoleEnum {
	TENANT_ADMIN = "tenant_admin",
	TENANT_USER = "tenant_user",
	TENANT_READ_ONLY_USER = "tenant_read_only_user",
}

export type TUserAuthState = {
	token: string | null;
	decodedToken: any;
	usernameFromToken: string | null;
	loginError: string | null;
	authStatus: {
		isLoggedIn: boolean;
		isLoading: boolean;
	};
	isPasswordSet: boolean;
	isMultiFactorAuthSet: boolean;
	loading: boolean;
	user: any;
	isGlobalAdmin: boolean | null;
	mfaError: AuthError | null;
	allUsers: {
		data: Array<any>;
		loading: boolean;
		error: any;
	};
};
